import { NavLink, Outlet } from 'react-router';

import { useUserInfo, isStoreManager } from '~domains/auth';

import { ROUTES } from '~shared/config/routes';
import { Container } from '~shared/ui/layout';

import { TableTab } from './table-tab/table-tab';

import { useLastVisitedTab } from '../lib/use-last-visited-tab';

export const TransactionsPage = () => {
  useLastVisitedTab();
  const userInfoQuery = useUserInfo();

  return (
    <Container>
      <div className="box-border min-h-full w-full pt-10 pb-16">
        <h2 className="mt-0 mb-10 text-4xl font-bold">Transactions</h2>
        <div className="flex flex-row">
          <NavLink
            to={ROUTES.transactions.loans}
            className="text-black/80 no-underline"
          >
            {({ isActive }) => (
              <TableTab isActive={isActive}>Signed&nbsp;loans</TableTab>
            )}
          </NavLink>
          {userInfoQuery.data && !isStoreManager(userInfoQuery.data) && (
            <NavLink
              to={ROUTES.transactions.payments}
              className="text-black/80 no-underline"
            >
              {({ isActive }) => (
                <TableTab isActive={isActive}>Payments</TableTab>
              )}
            </NavLink>
          )}
        </div>
        <div className="rounded-2xl bg-white p-8">
          <Outlet />
        </div>
      </div>
    </Container>
  );
};
